if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      requestAnimationFrame(() => this.#init());
    }

    #init() {

      const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      const freeShippingRemaining = cartTotal - Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      const cartItems = Array.from(document.querySelectorAll('[data-js-cart-item]'));
      const cajaNaturalProductId = '15669950906633';
      const paidSubscriptionProductIds = new Set(['15669950251273', '15669950480649']);
      const subscriptionProductIds = new Set([cajaNaturalProductId, ...paidSubscriptionProductIds]);
      const productIds = cartItems.map(item => item.getAttribute('data-product-id'));
      const hasCajaNatural = productIds.includes(cajaNaturalProductId);
      const hasPaidSubscription = productIds.some(id => paidSubscriptionProductIds.has(id));
      const hasRegularProducts = productIds.some(id => ! subscriptionProductIds.has(id));
      const cajaNaturalOnly = productIds.length > 0 && productIds.every(id => id === cajaNaturalProductId);
      const paidSubscriptionsOnly = productIds.length > 0 && productIds.every(id => paidSubscriptionProductIds.has(id));
      let shippingMessage = '';
      let shippingSuccess = false;

      if ( cajaNaturalOnly ) {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        shippingSuccess = true;
      } else if ( hasRegularProducts && hasCajaNatural && hasPaidSubscription ) {
        shippingMessage = 'La Caja Natural tiene el envío incluido. Las otras suscripciones llevan 4,95 € y el resto del pedido se calcula en el checkout.';
      } else if ( hasRegularProducts && hasCajaNatural ) {
        shippingMessage = 'La Caja Natural tiene el envío incluido. El envío del resto del pedido se calcula en el checkout.';
      } else if ( hasRegularProducts && hasPaidSubscription ) {
        shippingMessage = 'Las suscripciones llevan 4,95 € de envío. El resto del pedido se calcula en el checkout.';
      } else if ( hasCajaNatural && hasPaidSubscription ) {
        shippingMessage = 'La Caja Natural tiene el envío incluido. Forrajeo y Fresco llevan 4,95 € de envío.';
      } else if ( paidSubscriptionsOnly ) {
        shippingMessage = 'Envío de la suscripción: 4,95 €.';
      } else if ( freeShippingRemaining < 0 ) {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', this.#formatMoney(Math.abs(freeShippingRemaining), KROWN.settings.shop_money_format));
      } else {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        shippingSuccess = true;
      }

      if ( this.hasAttribute('data-show-alert') ) {
        this.innerHTML = `
          <div class="alert alert--wide alert--${shippingSuccess ? 'success' : 'note'}">
            ${shippingMessage}
          </div>`;
      } else {
        this.innerHTML = shippingMessage;
      }

    }
    
    #formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') === 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}